export default "__VITE_ASSET__CVs0hbhF__"